
(() => {
  const LIMIT = 30 * 60 * 1000;
 const KEY = 'lara_cart_started_at_v2';
  const ROOT = window.Shopify?.routes?.root || '/';
const RESET_KEY = 'lara_cart_reset_v2';
  let checking = false;

  async function getCart() {
    const response = await fetch(ROOT + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Cart ophalen mislukt');
    return response.json();
  }

  async function checkCart() {
    if (checking) return;
    checking = true;

    try {
      const cart = await getCart();

     if (!localStorage.getItem(RESET_KEY)) {
  const response = await fetch(ROOT + 'cart/clear.js', {
    method: 'POST',
    credentials: 'same-origin'
  });

  if (!response.ok) {
    throw new Error('Eerste reset mislukt');
  }

  localStorage.setItem(RESET_KEY, 'yes');
  localStorage.removeItem(KEY);

  if (cart.item_count > 0) {
    window.location.reload();
  }
  return;
}

if (cart.item_count === 0) {
  localStorage.removeItem(KEY);
  return;
}
      

      const now = Date.now();
      let started = Number(localStorage.getItem(KEY));

      if (!started || started > now) {
        started = now;
        localStorage.setItem(KEY, String(started));
      }

      if (now - started >= LIMIT) {
        const response = await fetch(ROOT + 'cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Cart legen mislukt');
        }

        localStorage.removeItem(KEY);
        window.location.reload();
      }
    } catch (error) {
      console.error('Cart expiry:', error);
    } finally {
      checking = false;
    }
  }

  checkCart();
  setInterval(checkCart, 15000);
  window.addEventListener('pageshow', checkCart);
  window.addEventListener('focus', checkCart);
})();
